import React from 'react';
import { useLocation } from 'react-router-dom';
import { ENABLE_RECENTLY_VISITED_HISTORY } from '@atlassian/cssxp-utils-generic';
import { useApplicationContext, useFeatureToggle, useRecentlyViewed } from '../../index';
import { APP_PPC } from '@atlassian/temp-client-utils';
import { GENERIC_ERROR_PATH, UNAUTHORIZED_PATH } from '@atlassian/cssxp-typescommon';
import { routePaths } from '@css-xp/ppc-constants';

interface StoreRecentlyViewedProps {
  appName: string;
  trackTitle?: boolean;
  maxPerAppCount?: number;
  maxPerEntityCount?: number;
  enableUserIdAsStoragePrefix?: boolean;
}

export const StoreRecentlyViewed = ({
  appName,
  trackTitle,
  maxPerAppCount,
  maxPerEntityCount,
  enableUserIdAsStoragePrefix,
}: StoreRecentlyViewedProps) => {
  const { updateRecentlyViewed, init } = useRecentlyViewed();
  const [isEnabled] = useFeatureToggle();
  const location = useLocation();
  const context = useApplicationContext();
  if (!maxPerAppCount && context.uiConfig && context.uiConfig.recentlyVisited.maxPerAppCount) {
    maxPerAppCount = context.uiConfig.recentlyVisited.maxPerAppCount;
  }
  if (!maxPerEntityCount && context.uiConfig && context.uiConfig.recentlyVisited.maxPerEntityCount) {
    maxPerEntityCount = context.uiConfig.recentlyVisited.maxPerEntityCount;
  }

  const getRoutesToNotTrack = () => {
    return [GENERIC_ERROR_PATH, routePaths.home, UNAUTHORIZED_PATH];
  };

  const storagePrefix = enableUserIdAsStoragePrefix ? context.atlassianAccountId : '';
  init({
    appName,
    trackTitle,
    maxPerAppCount,
    maxPerEntityCount,
    storagePrefix,
  });

  const routesToNotTrack = getRoutesToNotTrack();

  React.useEffect(() => {
    if (
      isEnabled(ENABLE_RECENTLY_VISITED_HISTORY) &&
      appName === APP_PPC &&
      !routesToNotTrack.includes(location.pathname)
    ) {
      const url = location.pathname;
      updateRecentlyViewed({ url });
    }
  }, [location.pathname]);

  return null;
};
